import React, { Component, ReactNode } from 'react';
import { SubNavEnum } from './models/SubNavEnum';

interface State {
  isSideNavOpen: boolean;
  openSubNav: SubNavEnum;
}

interface Context {
  state: State;
  toggleSideNav: () => void;
  setOpenSubNav: (subNav: SubNavEnum) => void;
}

interface Props {
  children: ReactNode;
}

const { Provider, Consumer: SideNavConsumer } = React.createContext<Context>({} as Context);

class SideNavProvider extends Component<Props, State> {
  state = {
    isSideNavOpen: false,
    openSubNav: SubNavEnum.NONE,
  };

  toggleSideNav = () => {
    // Toggle sidenav state, and close any opened subnav.
    this.setState(
      {
        isSideNavOpen: !this.state.isSideNavOpen,
        openSubNav: SubNavEnum.NONE,
      },
      () => {
        this.saveNavStateForCurrentSession();
      }
    );
  };

  setOpenSubNav = (subNav: SubNavEnum) => {
    const isSideNavOpen = this.state.isSideNavOpen;
    const openSubNav = this.state.openSubNav;

    // Open SideNav if it is closed to allow showing the required SubNav
    if (isSideNavOpen === false) {
      this.setState(
        {
          isSideNavOpen: true,
          openSubNav: subNav,
        },
        () => this.saveNavStateForCurrentSession()
      );
    }
    if (openSubNav === subNav) {
      this.setState({
        openSubNav: SubNavEnum.NONE,
      });
    } else {
      this.setState({
        openSubNav: subNav,
      });
    }
  };

  getNavStateFromLocalStorage() {
    const menuState = localStorage.getItem('menu-state');
    return !menuState || menuState === 'closed' ? false : true;
  }

  saveNavStateForCurrentSession() {
    const transformedNavState = this.state.isSideNavOpen ? 'open' : 'closed';
    localStorage.setItem('menu-state', transformedNavState);
  }

  restoreNavStateFromPreviousSession() {
    const menuState = this.getNavStateFromLocalStorage();
    this.setState({
      isSideNavOpen: menuState,
    });
  }

  componentDidMount() {
    this.restoreNavStateFromPreviousSession();
  }

  render() {
    return (
      <Provider
        value={
          {
            state: this.state,
            toggleSideNav: this.toggleSideNav,
            setOpenSubNav: this.setOpenSubNav,
          } as Context
        }
      >
        {this.props.children}
      </Provider>
    );
  }
}

export { SideNavProvider, SideNavConsumer };
